module.exports = __webpack_public_path__ + "img/Artboard – 3 1.c9ec82f2.png";